import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { isFetchingFeatureFlags } from '@core/selectors/classroom';

import InboxCont from './Inbox.container';
import InboxContV4 from './InboxV4.container';

const InboxContainer = (props) => {
  const {
    webAppFtMuiV6MessagePageSidebar202412,
    webAppFtResponsiveMessages202506,
  } = useFlags();

  const fetchingFeatureFlags = useSelector(isFetchingFeatureFlags);

  if (fetchingFeatureFlags) {
    return null;
  }

  // Conditionally render the appropriate component based on the feature flag
  // Pass down all received props so the children components can access them
  return webAppFtMuiV6MessagePageSidebar202412
    ? // eslint-disable-next-line react/jsx-filename-extension
      !webAppFtResponsiveMessages202506 && <InboxCont {...props} />
    : !webAppFtResponsiveMessages202506 && <InboxContV4 {...props} />;
};

export default InboxContainer;
